<template>
   <div class="p-5">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :search="search"
      class="elevation-1"
    >

        <template v-slot:item.service="{ item }"> 
            <!-- <v-chip small class="ma-2" color="indigo darken-3" outlined>{{ item.service }}</v-chip> -->
            <v-chip :class="getChipStyle(item.service)">{{ item.service }}</v-chip>
            <!-- <v-chip class="custom-chip">{{ item.service }}</v-chip>  -->
        </template>

        <template v-slot:item.date="{ item }"> 
            {{ formatDate(item.date) }}
        </template>

        <template v-slot:item.value="{ item }"> 
            {{ formatBytes(item.value, unitType) }}
        </template>

        <!-- ALL인 경우에는 total 조회 ver -->
        <template v-if="search == 'all' || search == null || search == ''" v-slot:body.append>
            <tr v-if="items.length > 0">
                <td><strong>Total</strong></td>
                <td v-for="(header, index) in headers.slice(1)" :key="index">
                    <strong v-if="index == 1">{{ formatBytes(getTotal(header.value), unitType) }}</strong>
                </td>
            </tr>
        </template>
        <!--

        -->
    
        <!-- 필터링된 데이터에 맞게 total 변경 ver -->
        <!-- <template v-slot:body.append>
            <tr>
                <td><strong>Total</strong></td>
                <td v-for="(header, index) in headers.slice(1)" :key="index">
                    <strong v-if="index == 1">{{ formatBytes(getTotalWithItem(items, header.value), unitType) }}</strong>
                </td>
            </tr>  
        </template> -->

    </v-data-table>
  </div>
</template>

<script>
export default {
    name: 'UsagebyService',
    data() {
        return {
           
        }
    },
    props: ['headers', 'items', 'loading', 'unitType', 'search'],
    computed: {
   
    },
    methods: {
        formatBytes(bytes, unit = null) {
            // if (bytes === 0) return '';
            const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            if (unit && units.includes(unit)) {
                const index = units.indexOf(unit);
                // const size = (bytes / Math.pow(1000, index)).toFixed(2);
                // return `${size} ${unit}`;
                const size = (bytes / Math.pow(1000, index));
                return `${unit === 'B' ? size.toFixed(0) : size.toFixed(2)} ${unit}`;
            }

            const index = Math.floor(Math.log10(bytes) / 3);
            // const size = (bytes / Math.pow(1000, index)).toFixed(2);
            // return `${size} ${units[index]}`;
            const size = (bytes / Math.pow(1000, index));
            return `${index === 0 ? size.toFixed(0) : size.toFixed(2)} ${units[index]}`;
        },
        formatDate(date){
            return date.split(' ')[0];
        },
        getChipStyle(name){
            switch(name){
                case 'VOD':
                    return 'vod-chip';
                case 'HLS':
                    return 'hls-chip';
                case 'WEBRTC':
                    return 'webrtc-chip';
                default:
                    return '';
            }
        },
        getTotal(key){
            return this.items.reduce((sum, item) => sum + Number(item[key] || 0), 0);
        },
        getTotalWithItem(datas, key){
            return datas.reduce((sum, item) => sum + Number(item[key] || 0), 0);
        },
    },
}

</script>

<style scoped>
.custom-chip {
    background: #f0f7ff !important;
    color: #1e88e5 !important;
}

.vod-chip {
    background: #f0f7ff !important;
    color: #1e88e5 !important;
}

.hls-chip {
    /* background: #bbdefb !important;
    color: #1565c0 !important;  f3fcfa*/ 
    background: #ebf8f6  !important; 
    color: #009688  !important; 
}

.webrtc-chip {
    /* background: #90caf9 !important;
    color: #0d47a1 !important; */
    background: #fff4e6 !important; 
    color: #fb8c00 !important; 
}
</style>